// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getClaimTypes} from '../../../shared/repositories';

export const readClaimTypes = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const claimTypes = await getClaimTypes();

            dispatch({
                claimTypes,
                type: actions.UPDATE_CLAIM_HISTORY_CLAIM_TYPES
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };




// WEBPACK FOOTER //
// ./src/reports/claim-history/action-creators/read-claim-types.js